// src/components/about/AboutHero.jsx
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import fingerprintBg from "../../assets/images/fingerprint-bg.svg";

const AboutHero = () => {
  return (
    <section className="relative bg-gradient-to-br from-white via-blue-50 to-[#E5F8FA] py-24 overflow-hidden">
      <img
        src={fingerprintBg}
        alt="Background Pattern"
        className="absolute inset-0 w-full h-full object-cover opacity-10 pointer-events-none z-0"
      />

      <div className="relative z-10 max-w-7xl mx-auto px-4 text-center">
        <motion.h1
          initial={{ opacity: 0, y: -40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-4xl md:text-5xl font-heading font-bold text-primary mb-4"
        >
          About Us
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.2 }}
          className="text-lg md:text-xl text-gray-700 mb-8 max-w-2xl mx-auto font-body"
        >
          Creating impact through collaboration and innovation.
        </motion.p>


        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.4 }}
        >
          <Link
            to="/programs"
            className="inline-block bg-primary text-white font-medium px-6 py-3 rounded-full hover:bg-secondary transition shadow-md"
          >
            Explore Our Work
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutHero;
